// extracted by mini-css-extract-plugin
export var About = "style-module--About--0f660";
export var Description = "style-module--Description--2e019";
export var Image = "style-module--Image--57f3b";
export var ImageWrapper = "style-module--ImageWrapper--a41ba";